import { StyleSheet, Text, View, ScrollView } from 'react-native'

// styles
import { colorPalette, globalStyles } from '../static/styles/global'
import { skeletonStyles } from '../static/styles/skeleton'

// components
import Card from '../components/shared/card/Card'
import MyScrollView from '../components/shared/navigator/MyScrollView'

const OnBoardingFormsSkeleton = () => {
  return (
    <MyScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[skeletonStyles.headerNav]} />
        <View style={[globalStyles.horizontalPadGap, globalStyles.vCenterItems, globalStyles.vDirection]}>
          <View style={[skeletonStyles.headerHeading]} />
          <View style={[skeletonStyles.headerDescription]} />
          <View style={[skeletonStyles.headerDescription]} />
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        {[1, 2, 3].map((row) => (
          <Card key={row}>
            <View style={[styles.cardBoardCategory]} />
            <View style={[styles.cardBoardItem]}>
              <View style={[styles.cardBoardType]}></View>
            </View>
          </Card>
        ))}
      </View>
    </MyScrollView>
  )
}

const styles = StyleSheet.create({
  cardBoardItem: {
    flex: 1,
    backgroundColor: colorPalette.light,
    opacity: 0.6,
    borderRadius: 8,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    minHeight: 70,
    marginHorizontal: -8,
    marginBottom: -6
  },
  cardBoardCategory: {
    backgroundColor: colorPalette.lightDark,
    opacity: 0.6,
    alignSelf: 'center',
    alignItems: 'center',
    minWidth: 200,
    marginTop: -18,
    marginBottom: 30,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingVertical: 20,
    paddingHorizontal: 12
  },
  cardBoardType: {
    backgroundColor: colorPalette.lightDark,
    opacity: 0.6,
    borderRadius: 8,
    minWidth: 70,
    justifyContent: 'center'
  }
})

export default OnBoardingFormsSkeleton
